
<div class="mt-4">
  <div class="row">
    <div class="col">
      <h3>Object Model Diagram</h3>
      <p>Can drag nodes and zoom (unset position with shift). Click a node to jump to its builder. Toggle displaying node types with the legend. Press Organize a few times if everything is jumbled.</p>
      <button class="btn green" v-on:click="savePng">Save PNG</button>
      <button class="btn green" v-on:click="reset">Reset</button>
      <button class="btn green" v-on:click="generateGraph">Organize</button>
      <div id="graph" class="d3-graph"></div>
    </div>
  </div>
</div>
